$(document).ready(function () {    

    $('.categories-content').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 992,
                settings: 'unslick'
            }
        ]
    });

    $('.select-type .nav-item').click(function(){
        var elem        = $(this),
            parent      = elem.parent(),
            items       = parent.find('.nav-item'),
            index       = items.index(elem),
            categories  = $('.categories-content-wrapper'),
            content     = $('.tab-content'),
            nav         = $('.select-type');
        
        categories.hide();
        categories.eq(index).show();
        content.find('.tab-pane').removeClass('show active');
        nav.find('.nav-link').removeClass('active');
        content.each(function(){
            var items = $(this).find('.tab-pane').eq(index).addClass('show active');
        });
        nav.each(function(){
            var items = $(this).find('.nav-link').eq(index).addClass('active');
        })

        if($(window).width() < 992){
            $('.categories-content').slick('setPosition'); 
        }
        
    })

    $(window).on('resize', function(){
        $('.categories-content').slick('setPosition');
        if($(window).width() < 992){
            $('.categories-content').slick('refresh'); 
        }
    })

});